import { useQuery } from '@tanstack/react-query'

import { GetDetalhesLoteService } from '@/features/produtos/services/get-detalhes-lote.service'
import { produtosKeys } from '@/features/produtos/utils'

export const useDetalhesLote = (idExterno: number) => {
  return useQuery({
    queryKey: produtosKeys.detalheLote(idExterno),
    queryFn: () => new GetDetalhesLoteService().execute(idExterno).then(({ data }) => data),
    enabled: idExterno > 0,
  })
}
